import React from 'react';

import { formatAccountNumber } from '@eika-infrastruktur/format';

import type { Transaction, TransactionActor } from '../../generated-types';
import useTransactionActor from '../../hooks/useTransactionActor';
import useTranslation from '../../hooks/useTranslation';

interface Props {
    transaction: Transaction;
}

const ifNotEmpty = (value: string | undefined, alternativeValue: string | undefined = undefined) =>
    value && value.length > 0 ? value : alternativeValue;

const getActor = (actor?: TransactionActor) => ifNotEmpty(actor?.name, formatAccountNumber(actor?.accountNumber));

const TransactionDescription: React.FC<Props> = ({ transaction }) => {
    const translation = useTranslation();

    const isFromAccount = transaction.transactionAmount > 0;
    const isToAccount = transaction.transactionAmount < 0;

    const { transactionActor: toActor } = useTransactionActor(transaction.to, true, isToAccount);
    const { transactionActor: fromActor } = useTransactionActor(transaction.from, true, isFromAccount);

    if (getActor(fromActor) && isFromAccount) {
        return `${translation.transactionDetails.from}: ${getActor(fromActor)}`;
    }
    if (getActor(toActor) && isToAccount) {
        return `${translation.transactionDetails.to}: ${getActor(toActor)}`;
    }

    return transaction.text;
};

export default TransactionDescription;
